import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkarrow",
  "use": "linkarrow-usage",
  "viewBox": "0 0 5.8 13.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 5.8 13.9\" id=\"linkarrow\">\n<g>\n\t<path d=\"M4.1,6.9L0,0h1.7l4.1,6.9l-4.1,6.9H0L4.1,6.9z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol